module.exports = __webpack_public_path__ + "adbccc4d9b2c65563cc7b6eb95ce728f.png";